import TopBar from "components/ui/TopBar/TopBar";
import Gator from "components/displays/Gator/Gator";

function App() {
  return (
    <>
      <TopBar />
      <Gator />
    </>
  );
}

export default App;
